module.exports = __webpack_public_path__ + "img/center-default-title.1fff8786.png";